module.exports = __webpack_public_path__ + "static/media/sprtlook-1.dc2633b5.svg";